"use client";
import React from "react";

// Helpers
import type { BenefitProps } from "./interface";
import styles from "./Benefit.module.scss";

// Components
import { Flex } from "@/app/[lang]/components/ui/AntdLite";
import Image from "next/image";
import DOMPurify from "@/app/[lang]/utils/dompurify";
import classnames from "classnames";
import {getSafeHeading, getStrapiMedia, isSvgUrl} from "@/app/[lang]/utils/api-helpers";

export const Benefit = ({ data }: { data: BenefitProps }) => {

    if ( !!data.hidden ) {
        return null;
    }

    const TitleTag = getSafeHeading(data?.headingLevel, "h3");
    const iconSrc = getStrapiMedia(data.icon?.data?.attributes?.url);

    return (
    <section className={styles.wrapper}>
      <Flex vertical>
        {iconSrc && (
          <Image
            className={ styles.benefitIcon }
            src={iconSrc}
            alt={data.icon.data?.attributes?.alternativeText || "PPC Blue Romania"}
            width={80}
            height={80}
            loading="lazy"
            decoding="async"
            unoptimized={isSvgUrl(iconSrc)}
          />
        )}

        <TitleTag className={ classnames( 'h2', styles.benefitTitle ) } dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.title) }} />
        <div className={ styles.benefitDescription } dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.description) }} />
      </Flex>
    </section>
  );
};
